<template>
  <div id="app">
    
    <h1>PentaQ英雄联盟助手</h1>
    <p>
      <router-link to="/" style="margin: 0 10px">比赛复盘</router-link>
      <router-link to="/hero" style="margin: 0 10px">英雄</router-link>
      <router-link to="/item" style="margin: 0 10px">装备</router-link>
      <router-link to="/summoner" style="margin: 0 10px">召唤师技能</router-link>
      <router-link to="/rune" style="margin: 0 10px">符文</router-link>
    </p>

    <hr style="margin-bottom: 20px">

    <router-view></router-view>

    <div style="height: 100px; clear: both"></div>
  </div>
</template>

<script>

export default {
  name: 'app',
  components: {}
}
</script>

<style scoped>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
